<template>
  <v-container fluid grid-list-xl class="p-0">
    <v-progress-linear
      class="mt-1"
      indeterminate
      color="primary"
      :style="loadingStats < 3 ? '' : 'visibility:hidden;'"
    ></v-progress-linear>

    <v-layout wrap>
      <v-flex xs12 sm6 md4>
        <v-card class="flex-card" style="height: 100%">
          <v-card-title>
            <div class="headline">Aktivitet i dag</div>
          </v-card-title>
          <v-card-text class="d-flex align-center">
            <influencer-activity-chart v-model="activityStatsToday" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card class="flex-card" style="height: 100%">
          <v-card-title>
            <div class="headline">Aktivitet seneste 30 dage</div>
          </v-card-title>
          <v-card-text class="d-flex align-center">
            <influencer-activity-chart v-model="activityStats" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-card class="flex-card" style="height: 100%">
          <v-card-title>
            <div class="headline">Aktivitet forrige 30 dage</div>
          </v-card-title>
          <v-card-text class="d-flex align-center">
            <influencer-activity-chart v-model="activityStatsLastPeriod" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import local_numbers from "@/helpers/filters/local_numbers";
import InfluencerActivityChart from "../../charts/InfluencerActivityChart";
import { mapActions } from "vuex";

export default {
  components: { InfluencerActivityChart },
  filters: { local_numbers },
  data: () => ({
    loadingStats: 0,
    activityStats: {},
    activityStatsLastPeriod: {},
    activityStatsToday: {}
  }),
  methods: {
    ...mapActions("moderator", ["getInfluencerActivityStats"]),

    getActivityStats() {
      const params = {
        starting_at: this.$moment()
          .startOf("day")
          .subtract(30, "day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        ending_at: this.$moment()
          .endOf("day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      };
      this.getInfluencerActivityStats(params).then(response => {
        this.activityStats = response;
        this.loadingStats++;
      });
    },
    getActivityStatsToday() {
      const params = {
        starting_at: this.$moment()
          .startOf("day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        ending_at: this.$moment()
          .endOf("day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      };
      this.getInfluencerActivityStats(params).then(response => {
        this.activityStatsToday = response;
        this.loadingStats++;
      });
    },
    getActivityStatsLastPeriod() {
      const params = {
        starting_at: this.$moment()
          .startOf("day")
          .subtract(60, "day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        ending_at: this.$moment()
          .endOf("day")
          .subtract(30, "day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      };
      this.getInfluencerActivityStats(params).then(response => {
        this.activityStatsLastPeriod = response;
        this.loadingStats++;
      });
    },
    getStats() {
      this.loadingStats = 0;

      this.getActivityStats();
      this.getActivityStatsToday();
      this.getActivityStatsLastPeriod();
    }
  },
  created() {
    this.getStats();

    this.interval = setInterval(() => {
      this.getStats();
    }, 60 * 1000);
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>
